import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { GameState, IGameRepresentationChangedArgs, IGameStateChangedArgs } from '@/components/game/_domain/models';
import { IHamsterRaceGameRepresentation } from '@/components/game/implementations/uk/hamster-race/_domain/controller/game-controller';
import { IGameController } from '@/components/game/_domain/models/game-controller';

@Component({
  name: 'HamsterRaceLastEightWinnersComponent'
})
export default class HamsterRaceLastEightWinnersComponent extends TombolaBaseComponent {
  @Prop() public gameController: IGameController;
  private lastEightWinnersNames: string[] = [];
  private gameState: GameState;
  private isVisible: boolean = true;

  private mounted() {
    Vue.nextTick(() => {
      this.gameController
          .onGameRepresentationChanged(this.handleGameRepresentationChanged)
          .onGameStateChanged(this.handleGameStateChanged);
    });
  }

  private handleGameRepresentationChanged(eventArgs: IGameRepresentationChangedArgs) {
    const gameRepresentation: IHamsterRaceGameRepresentation = eventArgs.currentGameRepresentation;

    this.lastEightWinnersNames = gameRepresentation.lastEightWinnersNames;
  }

  private handleGameStateChanged(eventArgs: IGameStateChangedArgs) {
    this.gameState = eventArgs.currentGameState;
    this.updateLastEigthWinnersVisibility();
  }

  private updateLastEigthWinnersVisibility() {
    if (this.gameState === GameState.WinnersDisplayed) {
      this.isVisible = false;
    }
    else if (this.gameState === GameState.Purchasing) {
      this.isVisible = true;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/hamster-race/_components/game-info/last-eight-winners/last-eight-winners.component.ts